import {
  NibbleChangePositionParams,
  NibbleCopyParams,
  NibbleCopySimpleParams,
  NibbleCreateInCollectionParams,
  NibbleCreateModel,
  NibbleCreateParams,
  NibbleEditCollRelatedCommentParams,
  NibbleEditCollRelatedNoteParams,
  NibbleGetCollRelatedNoteParams,
  NibbleGetModel,
  NibbleGetParams,
  NibbleMoveParams,
  NibbleMoveSimpleParams,
  NibbleRemoveFromCollectionByIdParams,
  NibbleRemoveFromCollectionByServiceValueParams,
  NibbleResolveCollRelatedCommentParams,
  NibbleUpdateParams
} from '@aipb/personal-content/shared/model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalContentApiService } from '../personal-content-api.service';
import { NibbleApiInterface } from './nibble-api.interface';

@Injectable({
  providedIn: 'root'
})
export class NibbleApiService implements NibbleApiInterface {
  constructor(private api: PersonalContentApiService) {}

  changePosition(params: NibbleChangePositionParams): Observable<any> {
    return this.api.post('nibbleChangePosition', params);
  }

  copy(params: NibbleCopyParams): Observable<any> {
    return this.api.post('nibbleCopy', params);
  }

  copySimple(params: NibbleCopySimpleParams): Observable<any> {
    return this.api.post('nibbleCopy_simple', params);
  }

  create(params: NibbleCreateParams): Observable<NibbleCreateModel> {
    return this.api.post('nibbleCreate', params);
  }

  createInCollection(params: NibbleCreateInCollectionParams): Observable<any> {
    return this.api.post('nibbleCreateInCollection', params);
  }

  get(params: NibbleGetParams): Observable<NibbleGetModel> {
    return this.api.post('nibbleGet', params);
  }

  move(params: NibbleMoveParams): Observable<any> {
    return this.api.post('nibbleMove', params);
  }

  moveSimple(params: NibbleMoveSimpleParams): Observable<any> {
    return this.api.post('nibbleMove_simple', params);
  }

  removeFromCollectionByServiceValue(params: NibbleRemoveFromCollectionByServiceValueParams): Observable<any> {
    return this.api.post('nibbleRemoveFromCollectionByServiceValue', params);
  }

  update(params: NibbleUpdateParams): Observable<any> {
    return this.api.post('nibbleUpdate', params);
  }

  editCollRelatedNote(params: NibbleEditCollRelatedNoteParams): Observable<any> {
    return this.api.post('nibbleEditCollRelatedNote', params);
  }

  editCollRelatedComment(params: NibbleEditCollRelatedCommentParams): Observable<any> {
    return this.api.post('nibbleEditCollRelatedComment', params);
  }

  removeFromCollectionById(params: NibbleRemoveFromCollectionByIdParams): Observable<any> {
    return this.api.post('nibbleRemoveFromCollectionById', params);
  }

  getCollRelatedNote(params: NibbleGetCollRelatedNoteParams): Observable<any> {
    return this.api.post('nibbleGetCollRelatedNote', params);
  }

  resolveCollRelatedComment(params: NibbleResolveCollRelatedCommentParams): Observable<any> {
    return this.api.post('nibbleResolveCollRelatedComment', params);
  }
}
